export const InventoryAlertKinds = {
  ArrivalGreaterThanOrder: 'arrivalGreaterThanOrder',
  OrderGreaterThanArrival: 'orderGreaterThanArrival',
  StorageMoved: 'storageMoved',
} as const;

/**
 * 在庫管理ページのアラートのステータスタイプ
 */
export type InventoryAlertKinds = (typeof InventoryAlertKinds)[keyof typeof InventoryAlertKinds];

/**
 * 型がInventoryAlertKindsかどうかを判定する
 * @param arg - 判定する値
 */
export const isInventoryAlertKinds = (arg: any): arg is InventoryAlertKinds => {
  return Object.values(InventoryAlertKinds).includes(arg);
};
